export const filterByValue = (array, string) =>
  array.filter(o => Object.keys(o).some(k => String(o[k]).toLowerCase().includes(string.toLowerCase())))
